import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wagontype',
  templateUrl: './wagon.component.html',
  styleUrls: ['./wagon.component.css']
})
export class WagonViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
